import React, { FunctionComponent, useEffect, useMemo } from "react";
import { Center } from "@chakra-ui/react";
import BoldSpinner from "components/BoldSpinner";
import useFetchAllV2Ids from "hooks/useFetchAllV2Ids";
import V2sContext, { V2sContextValue } from "contexts/V2sContext";

type V2sProviderProps = {};

const V2sProvider: FunctionComponent<V2sProviderProps> = ({ children }) => {
  const [allV2Ids, fetchAllV2s, isLoading] = useFetchAllV2Ids();

  const contextValue = useMemo<V2sContextValue>(
    () => ({
      allV2Ids: allV2Ids || [],
      fetchAllV2s,
      isLoading,
    }),
    [allV2Ids, fetchAllV2s, isLoading]
  );

  useEffect(() => {
    fetchAllV2s();
  }, [fetchAllV2s]);

  return (
    <V2sContext.Provider value={contextValue}>
      {isLoading ? (
        <Center h="100vh">
          <BoldSpinner size="xl" />
        </Center>
      ) : (
        children
      )}
    </V2sContext.Provider>
  );
};

export default V2sProvider;
